import { useEffect } from 'react';

export const useAnalytics = () => {
  // Track page view on component mount
  useEffect(() => {
    trackEvent('page_view');
  }, []);

  const trackEvent = async (eventType, buttonName = null) => {
    try {
      await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/track`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          event_type: eventType,
          button_name: buttonName,
          user_agent: navigator.userAgent,
        }),
      });
    } catch (error) {
      console.error('Error tracking event:', error);
    }
  };

  const trackButtonClick = (buttonName) => {
    trackEvent('button_click', buttonName);
  };

  return { trackButtonClick };
};

export default useAnalytics;